import Vue from "vue";
import axios from "axios";
import "../../../../filters";
import moment from "moment";
import { FormWizard, TabContent } from "vue-form-wizard";

import { validationMixin } from "vuelidate";
import {
  required,
  minValue,
  maxValue,
  integer,
} from "vuelidate/lib/validators";

const tariffAllocTotalPerc = (value) => value == 100;

export default {
  name: "CaptureProperty",
  mixins: [validationMixin],
  components: {
    attachmentsComp: require("../../../../components/attachments.vue").default,
    DataGridComp: require("../../../../customcontrols/datagrid.vue").default,
    AddressComp:
      require("@/components/addressCodedUncoded/addressCodedUncoded.vue")
        .default,
  },
  props: ["dataObj"],
  data: function () {
    return {
      addressDataObj: null,
      appId: -1,
      connExpiryDate2: null,
      eDate2: null,
      tariffAllocationGridCols: [],
      tariffAllocationKeyColumn: "cType",
      tariffAllocationDialog: false,
      editTariffAllocation: false,
      editTariffAllocationIdx: -1,
      tariffAllocation: {
        connectionId: -1,
        cType: "",
        description: "",
        groupDescription: "",
        percWater: null,
        percSewer: null,
        noUnits: null,
        estimConsPU: null,
      },

      totalPercentage: {
        totalWaterPerc: 0,
        totalSewerPerc: 0,
      },

      removeTariffAllocationDialog: false,

      currentTab: "tab-address", //"tab-propertyServices",
    };
  },
  validations: {
    dataObj: {
      propertyServicesData: {
        consumptionType: {
          required,
        },
      },
    },
    tariffAllocation: {
      cType: {
        required,
      },
      percWater: {
        required,
        minValue: minValue(0.1),
        maxValue: maxValue(100),
      },
      percSewer: {
        maxValue: maxValue(100),
      },
      noUnits: {
        required,
        integer,
        minValue: minValue(1),
      },
      estimConsPU: {
        integer,
        minValue: minValue(0),
      },
    },
    totalPercentage: {
      totalWaterPerc: {
        minValue: minValue(100),
        maxValue: maxValue(100),
      },
      totalSewerPerc: {
        maxValue: maxValue(100),
      },
    },
  },
  computed: {},
  watch: {},
  created() {
    this.$material.locale.dateFormat = "dd/MM/yyyy";
    this.$root.$on("capture_property_updated", this.init);
    this.fillTariffAllocationGridCols();
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;

        this.connExpiryDate2 = moment(
          this.dataObj.propertyServicesData.connExpiryDate
        ).format("DD/MM/YYYY");
        this.eDate2 = moment(this.dataObj.otherDetails.eDate).format(
          "DD/MM/YYYY"
        );

        if (this.dataObj.hasTariffAlocation) {
          this.calcTariffAllocationTotalPercentage();
        }

        this.addressDataObj = {
          addressTypes: this.dataObj.addressTypes,
          postalData: {
            addressType: this.dataObj.addressData.addressType,

            postalAddress: this.dataObj.addressData.streetName,
            ownerAddress: this.dataObj.addressData.area,
            contact: this.dataObj.addressData.township,
            ownerFullName: this.dataObj.addressData.town,
            buildingName: this.dataObj.addressData.buildingName,

            //coded
            careOf: this.dataObj.addressData.careOf,
            code: this.dataObj.addressData.code,
            flatName: this.dataObj.addressData.flatName,
            flatNumber: this.dataObj.addressData.flatNumber,
            houseNumber: this.dataObj.addressData.houseNumber,
          },
          readOnly: this.dataObj.readOnly,
        };
      });
    },

    setPropertyServicesData() {
      this.dataObj.propertyServicesData.connExpiryDate = moment(
        this.connExpiryDate2,
        "DD/MM/YYYY"
      ).add(1, "days");

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(this.dataObj.propertyServicesData)),
      };

      return axios
        .post("/CapturePropertyActivity/SetPropertyServicesData", parameter)
        .then((response) => {
          if (response.status == 200) {
            return true;
          } else {
            this.$alertMsg(
              this.$t("messages.SetCapturePropertyServicesFailure")
            );
            return false;
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
          return false;
        });
    },
    showInGoogleMap() {
      var address = "";
      if (this.addressData.addressType === 1)
        address = this.addressData.buildingName;
      else if (this.addressData.addressType === 0)
        address = this.addressData.buildingName;

      window.open("http://map.google.com/?oe=utf8&q={0}" + address);
    },
    setAddressData() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(this.dataObj.addressData)),
      };

      return axios
        .post("/CapturePropertyActivity/SetAddressData", parameter)
        .then((response) => {
          if (response.status == 200) {
            return true;
          } else {
            this.$alertMsg(
              this.$t("messages.SetCapturePropertyAddressFailure")
            );
            return false;
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
          return false;
        });
    },
    setOtherDetails() {
      this.dataObj.otherDetails.eDate = moment(this.eDate2, "DD/MM/YYYY").add(
        1,
        "days"
      );

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(this.dataObj.otherDetails)),
      };

      return axios
        .post("/CapturePropertyActivity/SetOtherData", parameter)
        .then((response) => {
          if (response.status == 200) {
            return true;
          } else {
            this.$alertMsg(
              this.$t("messages.SetCapturePropertyOtherDetailsFailure")
            );
            return false;
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
          return false;
        });
    },
    setComments() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(this.dataObj.comments)),
      };

      return axios
        .post("/CapturePropertyActivity/SetComments", parameter)
        .then((response) => {
          if (response.status == 200) {
            return true;
          } else {
            this.$alertMsg(
              this.$t("messages.SetCapturePropertyCommentsFailure")
            );
            return false;
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
          return false;
        });
    },
    setTariffAllocationData() {
      if (!this.dataObj.hasTariffAlocation) return true;

      var parameters = {
        ApplicationId: Number(this.appId),
        ApplicationKey: 0,
        Items: this.dataObj.tariffAllocationData.tariffAllocations,
      };

      return axios
        .post("/CapturePropertyActivity/SetTariffAllocationData", parameters)
        .then((response) => {
          if (response.status == 200) {
            return true;
          } else {
            this.$alertMsg(
              this.$t("messages.SetCapturePropertyCommentsFailure")
            );
            return false;
          }
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
          return false;
        });
    },
    getValidationClass(data, objName, fieldName) {
      if (fieldName == "") {
        const field = this.$v[data][objName];

        if (field) {
          return {
            "md-invalid": field.$invalid && field.$dirty,
          };
        }
      } else {
        const field = this.$v[data][objName][fieldName];

        if (field) {
          return {
            "md-invalid": field.$invalid && field.$dirty,
          };
        }
      }
    },

    validateAppData() {
      if (
        this.dataObj.hasTariffAlocation &&
        this.dataObj.tariffAllocations.length > 0
      )
        this.$v.totalPercentage.$touch();

      this.$v.dataObj.propertyServicesData.$touch();

      if (this.$v.dataObj.propertyServicesData.$invalid) {
        this.currentTab = "tab-propertyServices";
        return false;
      }

      if (
        this.dataObj.hasTariffAlocation &&
        this.dataObj.tariffAllocations.length > 0 &&
        this.$v.totalPercentage.$invalid
      ) {
        this.currentTab = "tab-tariffAllocation";
        return false;
      }

      // && (this.dataObj.hasTariffAlocation ? true : !this.$v.totalPercentage.$invalid)
      if (
        !this.$v.dataObj.propertyServicesData.$invalid &&
        (!this.dataObj.hasTariffAlocation ||
        (this.dataObj.hasTariffAlocation &&
          this.dataObj.tariffAllocations.length == 0)
          ? true
          : !this.$v.totalPercentage.$invalid)
      ) {
        return true;
      } else {
        return false;
      }
    },
    fillTariffAllocationGridCols() {
      this.tariffAllocationGridCols.push({
        dataField: "cType",
        caption: this.$t("activities.consumptionType"),
      });
      this.tariffAllocationGridCols.push({
        dataField: "groupDescription",
        caption: this.$t("activities.groupDescription"),
      });
      this.tariffAllocationGridCols.push({
        dataField: "description",
        caption: this.$t("activities.description"),
      });
      this.tariffAllocationGridCols.push({
        dataField: "percWater",
        caption: this.$t("activities.percentageForWater"),
      });
      this.tariffAllocationGridCols.push({
        dataField: "percSewer",
        caption: this.$t("activities.percentageForSewer"),
      });
      this.tariffAllocationGridCols.push({
        dataField: "noUnits",
        caption: this.$t("activities.noOfUnits"),
      });
      this.tariffAllocationGridCols.push({
        dataField: "estimConsPU",
        caption: this.$t("activities.estimConsPU"),
      });
    },
    addTariffAllocation() {
      this.editTariffAllocation = false;

      this.tariffAllocation = {
        connectionId: -1,
        cType: "",
        description: "",
        groupDescription: "",
        percWater: null,
        percSewer: null,
        noUnits: null,
        estimConsPU: null,
      };

      this.$v.tariffAllocation.$reset();

      this.tariffAllocationDialog = true;
    },
    validateTariffAllocation() {
      if (this.tariffAllocation.percSewer == null) {
        this.tariffAllocation.percSewer = 0;
      }

      this.$v.tariffAllocation.$touch();

      if (!this.$v.tariffAllocation.$invalid) {
        if (this.editTariffAllocation) {
          var items = [];
          for (var i = 0; i < this.dataObj.tariffAllocations.length; i++) {
            if (i != this.editTariffAllocationIdx)
              items.push(this.dataObj.tariffAllocations[i]);
          }

          if (
            items.filter((a) => a.cType == this.tariffAllocation.cType).length >
            0
          ) {
            this.$alertMsg(this.$t("activities.consumptionTypeAlreadyExists"));
            return;
          }
        } else {
          if (
            this.dataObj.tariffAllocations.filter(
              (a) => a.cType == this.tariffAllocation.cType
            ).length > 0
          ) {
            this.$alertMsg(this.$t("activities.consumptionTypeAlreadyExists"));
            return;
          }
        }

        this.tariffAllocation.description =
          this.dataObj.tariffAllocationconsumptionTypes.filter(
            (a) => a.value == this.tariffAllocation.cType
          )[0].text;
        this.tariffAllocation.groupDescription =
          this.dataObj.tariffAllocationconsumptionTypes.filter(
            (a) => a.value == this.tariffAllocation.cType
          )[0].group.name;

        if (this.editTariffAllocation == true) {
          Vue.set(
            this.dataObj.tariffAllocations,
            this.editTariffAllocationIdx,
            this.tariffAllocation
          );
        } else this.dataObj.tariffAllocations.push(this.tariffAllocation);

        this.calcTariffAllocationTotalPercentage();
        this.tariffAllocationDialog = false;
      }
    },
    calcTariffAllocationTotalPercentage() {
      this.totalPercentage.totalWaterPerc = 0;
      this.totalPercentage.totalSewerPerc = 0;

      for (var i = 0; i < this.dataObj.tariffAllocations.length; i++) {
        this.totalPercentage.totalWaterPerc +=
          this.dataObj.tariffAllocations[i].percWater;
        this.totalPercentage.totalSewerPerc +=
          this.dataObj.tariffAllocations[i].percSewer == null
            ? 0
            : this.dataObj.tariffAllocations[i].percSewer;
      }
    },
    editTariffAllication(item, idx) {
      console.log(idx);
      this.editTariffAllocation = true;
      this.editTariffAllocationIdx = idx;

      this.tariffAllocation = JSON.parse(
        JSON.stringify(this.dataObj.tariffAllocations[idx])
      );

      this.$v.tariffAllocation.$reset();

      this.tariffAllocationDialog = true;
    },
    removeTariffAllication(item, idx) {
      this.editTariffAllocationIdx = idx;
      this.removeTariffAllocationDialog = true;
    },
    confirmRemoveTariffAllocation() {
      this.dataObj.tariffAllocations.splice(
        this.dataObj.tariffAllocations.indexOf(this.editTariffAllocationIdx),
        1
      );
      this.editTariffAllocationIdx = -1;
      this.calcTariffAllocationTotalPercentage();
      this.removeTariffAllocationDialog = false;
    },
    changeTab(e) {
      this.currentTab = e;
    },
  },
};
